import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: "dc-admin-auth",
  },
});

// Public read of active products (filtered server-side by RLS).
export async function fetchProducts() {
  const { data, error } = await supabase
    .from("products")
    .select("*")
    .eq("status", "active")
    .order("category", { ascending: true })
    .order("price_inr", { ascending: true });
  if (error) {
    console.error("fetchProducts error", error);
    return [];
  }
  return data || [];
}

export async function fetchProduct(id) {
  const { data, error } = await supabase
    .from("products")
    .select("*")
    .eq("id", id)
    .eq("status", "active")
    .maybeSingle();
  if (error) {
    console.error("fetchProduct error", error);
    return null;
  }
  return data;
}
